import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Användare'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Klient'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Arbetsgrupper'
, [ TEXT.UI_MENU_JOBS          ]: 'Uppgifter'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Nyckel master system'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Skapa'
, [ TEXT.UI_BUTTON_NEW         ]: 'Ny'
, [ TEXT.UI_BUTTON_OK          ]: 'Ok'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Avbryt'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Spara'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Logga in'
, [ TEXT.UI_BUTTON_SEND        ]: 'Skicka'


, [ TEXT.UI_EMAIL              ]: 'E-post'
, [ TEXT.UI_ROLE               ]: 'Roll'
, [ TEXT.UI_USERNAME           ]: 'Användare'
, [ TEXT.UI_NAME               ]: 'Namn'
, [ TEXT.UI_DATE               ]: 'Datum'
, [ TEXT.UI_ADDR               ]: 'Adress'
, [ TEXT.UI_DESC               ]: 'Beskrivning'
, [ TEXT.UI_PRICE              ]: 'Pris'
, [ TEXT.UI_NO_DATA            ]: 'Inga data'
, [ TEXT.UI_MACHINES           ]: 'Machines'
, [ TEXT.UI_USERS              ]: 'Användare'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Logga ut'
, [ TEXT.UI_MKS_TYPE           ]: 'Nyckel master systemtyp'
, [ TEXT.UI_KEY_APP            ]: 'Nyckelanvändning'
, [ TEXT.UI_CLIENT             ]: 'Klient'
, [ TEXT.UI_FILE               ]: 'Kort'
, [ TEXT.UI_SELECT_FILE        ]: 'Välj fil'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Användarnamn'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Moln'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Lösenord'



, [ TEXT.ARE_YOU_SURE          ]: 'Är du säker?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Fel användare / moln eller lösenord'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Fel användare / moln eller lösenord'
, [ TEXT.ERROR_INTERNAL        ]: 'Internt serverfel'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Tillträde beviljas ej'
, [ TEXT.ERROR_UNKNOWN         ]: 'Det var ett fel, och det är allt vi vet'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Sidan hittas inte'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Ny arbetsgrupp'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Redigera arbetsgrupp'
, [ TEXT.WORKGROUPS_NAME       ]: 'Namn'


, [ TEXT.USERS_NEW_TITLE       ]: 'Ny användare'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Redigera användare'


, [ TEXT.MACHINE_TYPE          ]: 'Maskintyp'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# uppgifter'
, [ TEXT.MACHINE_NAME          ]: 'Maskin'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Ny klient'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Redigera klient'
, [ TEXT.CLIENT_ADDRESS        ]: 'Adress'
, [ TEXT.CLIENT_CONTACT        ]: 'Kontakta'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'E-post'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefon'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Efternamn'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Födelsedag'
, [ TEXT.CLIENT_NOTES          ]: 'Anteckningar'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Filternamn'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Filtrera adress'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtrera kontakt'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adress'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Stad'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Provins'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Postnummer'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Land'


, [ TEXT.MACHINES_NEW          ]: 'Ny maskin'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Serienummer'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Redigera uppgifter'
, [ TEXT.JOB_NEW_TITLE         ]: 'Ny uppgifter'
, [ TEXT.JOB_KEY_TYPE          ]: 'Nyckeltyp'
, [ TEXT.JOB_NUM_KEYS          ]: 'Belopp'
, [ TEXT.JOB_MACHINE           ]: 'Maskin'
, [ TEXT.JOB_STATUS            ]: 'Status'
, [ TEXT.JOB_DATE              ]: 'Datum'
, [ TEXT.JOB_QUANTITY          ]: 'Nytt belopp'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filterstatus'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtrera klienter'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtermaskin'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filtrera efter nyckel'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtrera efter datum'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Start'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Start ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Ladda huvudnyckelsystem'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: '{num} nycklar skapas. Är du säker?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} jobb har skapats'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Master nyckel systemnamn'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Glömt ditt lösenord?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Skickade vilainstruktioner till'
, [ TEXT.LOGIN_SLOGAN                   ]: 'Den första molnbaserade nyckelduplikationsappen'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Registrera kopiorna av nycklarna som du gjort åt dina kunder</li>
  <br>
  <li>Lagra uppgifterna utan risk att förlora dem och få tillgång till dem var som helst</li>
  <br>
  <li>Automatiska uppdateringar</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Rättsligt meddelande'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Integritetspolicy'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Avtalsmodell'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/sv/legal_notice_sv.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/sv/privacy_policy_sv.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/sv/model_sv.docx'

, [ TEXT.KEY_MODEL                   ]: 'Nyckel'
, [ TEXT.KEY_SERIES                  ]: 'Serier'
, [ TEXT.KEY_CODE                    ]: 'Koda'
, [ TEXT.KEY_DATA_SHEET              ]: 'Kort'
, [ TEXT.KEY_BITING                  ]: 'Bitande'
, [ TEXT.KEY_APPLICATION             ]: 'Ansökan'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'I VÄNTAN PÅ'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'INSTÄLLT'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'KOMPLETT'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'BEHANDLING'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'BIL'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'HEM'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SÄKERHET'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'HÄNGLÅS'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'UNSPECIFIED'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Vänligen fyll i obligatoriska fält i rött'
}

export default ES ;
